import React from "react";
import "./Settings.css";

function Settings() {
  return (
    <div className="settings-container">
      <div className="settings-header">
        <h1 className="settings-title">Settings</h1>
        <p className="settings-subtitle">Manage your application settings</p>
      </div>

      <div className="settings-content">
        <div className="settings-section">
          <div className="settings-section-header">
            <span className="material-icons settings-section-icon">security</span>
            <div>
              <h2 className="settings-section-title">Security</h2>
              <p className="settings-section-description">Manage your password and security preferences</p>
            </div>
          </div>
          <div className="settings-section-content">
            <div className="settings-form-group">
              <label className="settings-label">Current Password</label>
              <input 
                type="password" 
                className="settings-input" 
                placeholder="Enter current password"
                readOnly
              />
            </div>
            <div className="settings-form-group">
              <label className="settings-label">New Password</label>
              <input 
                type="password" 
                className="settings-input" 
                placeholder="Enter new password"
                readOnly
              />
            </div>
            <div className="settings-form-group">
              <label className="settings-label">Confirm New Password</label>
              <input 
                type="password" 
                className="settings-input" 
                placeholder="Confirm new password"
                readOnly
              />
            </div>
            <button className="settings-save-btn" disabled>
              <span className="material-icons">lock</span>
              Update Password
            </button>
          </div>
        </div>

        <div className="settings-section">
          <div className="settings-section-header">
            <span className="material-icons settings-section-icon">notifications</span>
            <div>
              <h2 className="settings-section-title">Notifications</h2>
              <p className="settings-section-description">Configure your notification preferences</p>
            </div>
          </div>
          <div className="settings-section-content">
            <div className="settings-toggle-item">
              <div>
                <label className="settings-toggle-label">Email Notifications</label>
                <p className="settings-toggle-description">Receive email updates about important activities</p>
              </div>
              <label className="settings-toggle-switch">
                <input type="checkbox" disabled />
                <span className="settings-slider"></span>
              </label>
            </div>
            <div className="settings-toggle-item">
              <div>
                <label className="settings-toggle-label">Push Notifications</label>
                <p className="settings-toggle-description">Receive push notifications in your browser</p>
              </div>
              <label className="settings-toggle-switch">
                <input type="checkbox" disabled />
                <span className="settings-slider"></span>
              </label>
            </div>
            <div className="settings-toggle-item">
              <div>
                <label className="settings-toggle-label">SMS Notifications</label>
                <p className="settings-toggle-description">Receive SMS alerts for critical events</p>
              </div>
              <label className="settings-toggle-switch">
                <input type="checkbox" disabled />
                <span className="settings-slider"></span>
              </label>
            </div>
          </div>
        </div>

        <div className="settings-section">
          <div className="settings-section-header">
            <span className="material-icons settings-section-icon">language</span>
            <div>
              <h2 className="settings-section-title">Preferences</h2>
              <p className="settings-section-description">Customize your application preferences</p>
            </div>
          </div>
          <div className="settings-section-content">
            <div className="settings-form-group">
              <label className="settings-label">Language</label>
              <select className="settings-select" disabled>
                <option>English</option>
                <option>বাংলা (Bengali)</option>
              </select>
            </div>
            <div className="settings-form-group">
              <label className="settings-label">Timezone</label>
              <select className="settings-select" disabled>
                <option>Asia/Dhaka (GMT+6)</option>
                <option>UTC (GMT+0)</option>
              </select>
            </div>
            <div className="settings-form-group">
              <label className="settings-label">Date Format</label>
              <select className="settings-select" disabled>
                <option>DD/MM/YYYY</option>
                <option>MM/DD/YYYY</option>
                <option>YYYY-MM-DD</option>
              </select>
            </div>
            <button className="settings-save-btn" disabled>
              <span className="material-icons">save</span>
              Save Preferences
            </button>
          </div>
        </div>

        <div className="settings-section">
          <div className="settings-section-header">
            <span className="material-icons settings-section-icon">info</span>
            <div>
              <h2 className="settings-section-title">About</h2>
              <p className="settings-section-description">Application information and version</p>
            </div>
          </div>
          <div className="settings-section-content">
            <div className="settings-info-item">
              <span className="settings-info-label">Application Version:</span>
              <span className="settings-info-value">1.0.0</span>
            </div>
            <div className="settings-info-item">
              <span className="settings-info-label">Last Updated:</span>
              <span className="settings-info-value">Coming Soon</span>
            </div>
            <div className="settings-info-item">
              <span className="settings-info-label">Support:</span>
              <span className="settings-info-value">support@bibahobangla.com</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Settings;

